import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/messaging';
import 'firebase/firestore';
import { environment } from '@env';

@Injectable({
  providedIn: 'root',
})
export class FirebaseProviderService {
  private readonly firebaseApp: firebase.app.App;

  constructor() {
    this.firebaseApp = firebase.initializeApp(environment.firebaseConfig);
  }

  public getFirebaseMessaging(): firebase.messaging.Messaging {
    return firebase.messaging();
  }

  public isMessagingSupported(): boolean {
    return firebase.messaging.isSupported();
  }

  public getFirestore(): firebase.firestore.Firestore {
    return firebase.firestore(this.firebaseApp);
  }
}
